export function roundedDecimalPlace (value, digits=0) {
  var rounded = Math.pow(10, digits);
  return (Math.round(value * rounded) / rounded).toFixed(digits);
}
